import { DeleteOutlined, WarningOutlined } from '@ant-design/icons';
import { MenuFavorites } from "@dto/menuFavorites.dto";
import { Button, Drawer, Popconfirm } from "antd";
import { useState } from "react";
import { Link } from 'react-router-dom';
import { useAppGlobStore } from "src/appGlobalStore";
import { addOrDeleteMenuFavorite } from "src/component/breadcrumb/menuFavoritesService";
import { GridScope } from "src/component/grid/Grid";
import { XmHelp } from "src/component/help/XmHelp";
import { Log } from "src/service/log.service";
import { GLOB } from "src/util/Glob";
import { TextUtil } from "src/util/TextUtil";
import './menuFavorite.less';

type AlignType = 'left' | 'right' | 'center';

const myAlign: AlignType = 'center';

const MenuFavoritesDrawer = () => {
  const handleClose = () => GLOB.setAppState({ isFavoritesOpen: false });
  const menuFavorites = useAppGlobStore(s => s.menuFavorites);
  const removeMenuFavorite = useAppGlobStore(s => s.removeMenuFavorite);
  const [gs] = useState(() => new GridScope<MenuFavorites>('plain'));


  const removeFavorite = async (url: string, label: string) => {
    try {
      await addOrDeleteMenuFavorite({
        url: url,
        label: label,
        delete: true
      });

      removeMenuFavorite(url);
      Log.info('Summary favorite removed');
    } catch (error) {
      Log.error('Error removing summary favorite', error);
    }
  };

  const columns = [
    {
      title: 'Label',
      dataIndex: 'nonelol',
      key: 'label',
      sorter: (a, b) => GLOB.naturalSort(a.label, b.label),
      filterSearch: true,
      render: (val, record) => <span><Link onClick={handleClose} to={record.url}>{TextUtil.trimMiddle(record.label.split(" (")[0])}</Link></span>
    },
    {
      title: 'Path',
      dataIndex: 'label',
      key: 'path',
      sorter: (a, b) => GLOB.naturalSort(a.label, b.label),
      filterSearch: true,
      render: (val, record) => {
        let sub = val.substring(
          val.indexOf("(") + 1,
          val.lastIndexOf(")")
        ).trimEnd() as string;

        if (sub.endsWith("Summary") || sub.endsWith("Total")) sub = sub.substring(0, sub.lastIndexOf(">")).trim();

        return <span>{TextUtil.trimMiddle(sub)}</span>;
      }
    },
    {
      title: 'Delete',
      dataIndex: 'nonelollo',
      align: myAlign,
      key: 'delete',
      sorter: (a, b) => GLOB.naturalSort(a.label, b.label),
      filterSearch: true,
      render: (value, record) =>
        <Popconfirm
          okText="Delete"
          title={<span>Delete <b>{record.label.split(" (")[0]}</b> favorite.</span>}
          onConfirm={() => removeFavorite(record.url, record.label)}
          icon={
            <WarningOutlined style={{ fontSize: '1.5em', top: '0.25em' }} />
          }
        >
          <Button
            type='text'
            className='hover-danger text-center'
            icon={<DeleteOutlined />}
            size="small"
            title="Delete favorite." />
        </Popconfirm>
    },
  ];

  return (
    (<Drawer
      title={<span style={{ display: "flex", alignItems: "center" }}>Favorites <XmHelp style={{ fontSize: "1.1em" }} href="https://xormon.com/favorites.php" /></span>}
      open={GLOB.getAppState().isFavoritesOpen}
      onClose={handleClose}
      rootClassName='wrapper-glob-health-status'
      data-testid="favorites-panel"
    >
      {menuFavorites.length ?
        <gs.Grid
          key={"summary-table"}
          rowKey={"url"}
          renderProps={{ noClipboard: true }}
          showHeader={false}
          columns={columns}
          dataSource={menuFavorites}
          noScrollY
          className="xm-transparent-ant-table"
          style={{ paddingRight: "3em" }}
        /> : <></>
      }
    </Drawer>)
  );
};

export default MenuFavoritesDrawer;